import AuthRepo from '@/repository/auth'
import {
  destroyTokenData,
  getTokenData,
  saveTokenData,
  getImpersonationOrigin,
  hasImpersonationOrigin,
  clearImpersonationOrigin,
} from '@/services/token.service'
import DateConverter from '@/models/DateConverter'
const state = {
  isAuthenticated: !!getTokenData(),
  isImpersonating: hasImpersonationOrigin(),
  authData: null,
}

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  isImpersonating: state => state.isImpersonating,
  authData: state => state.authData,
}

const actions = {
  async preLogin(context, payload) {
    const { data } = await AuthRepo.login(payload)
    context.commit('setAuthData', { ...payload, ...data })
    return { ...payload, ...data }
  },
  seedAuthData(context) {
    const authData = JSON.parse(window.localStorage.getItem('authData'))
    if (!authData) return
    authData.fromLocalStorage = true
    context.commit('setAuthData', authData)
  },
  async onLogin(context, payload) {
    const { data } = await AuthRepo.login(payload)
    context.commit('setAuth', data)
    return data
  },
  async onLogout(context) {
    const tokenData = getTokenData()
    const { data } = await AuthRepo.logout({ tokenData })
    context.commit('purgeAuth')
    context.commit('ProfileModule/setProfile', null, { root: true })
    return data
  },
  exitImpersonation(context) {
    const origin = getImpersonationOrigin()
    if (!origin) return
    context.commit('setAuth', JSON.parse(origin))
    clearImpersonationOrigin()
    context.commit('setImpersonating', false)
    window.location.href = '/'
  },
  async onRefreshToken(context) {
    const tokenData = getTokenData()
    const refreshToken = tokenData ? JSON.parse(tokenData).refreshToken : ''
    const { data } = await AuthRepo.refreshToken({ refreshToken })
    context.commit('setAuth', data)
    return data
  },
  onVerifyAuth(context) {
    if (getTokenData()) {
      if (!context.rootGetters['ProfileModule/profile']) return context.dispatch('reLoadProfile')
    } else {
      context.commit('purgeAuth')
    }
  },
  async reLoadProfile(context) {
    const { profile } = await context.dispatch('ProfileModule/loadProfile', null, { root: true })
    DateConverter.configure()
    return profile
  },
}

const mutations = {
  setAuth(state, data) {
    state.isAuthenticated = true
    saveTokenData(JSON.stringify(data))
  },
  purgeAuth(state) {
    state.isAuthenticated = false
    state.isImpersonating = false
    destroyTokenData()
    clearImpersonationOrigin()
  },
  setImpersonating(state, value) {
    state.isImpersonating = value
  },
  setAuthData(state, data) {
    if (!data.fromLocalStorage) {
      window.localStorage.setItem('authData', JSON.stringify(data))
    }
    state.authData = data
  },
  destroyAuthData(state) {
    window.localStorage.removeItem('authData')
    state.authData = null
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
